import React from 'react';
import { injectIntl } from 'react-intl';
import Modal from '@Components/Modal';
import { isMultilingual } from 'getOpCoRoutes';
import Logger from '@ffw/logger-lib';

function SaveJobModal({ active, modalClose, intl }) {
  if (!active) {
    return null;
  }
  let href = process.env.REACT_APP_MYRANDSTAD_REGISTER_URL;
  if (isMultilingual()) {
    try {
      href = JSON.parse(href)[intl.locale];
    } catch (e) {
      Logger.error('REACT_APP_MYRANDSTAD_REGISTER_URL, is not a valid json object.');
    }
  }
  return (
    <Modal
      title={intl.formatMessage({ id: 'SaveJobModal.HeaderText' })}
      footer={(
        <a
          href={href}
          className="button button--m button--filled button--full-width"
        >
          {intl.formatMessage({ id: 'SaveJobModal.ButtonText' })}
        </a>
      )}
      onClose={modalClose}
      id="save-jobs"
    >
      <p className="form__header">
        {intl.formatMessage({ id: 'SaveJobModal.MainText' }, { total: process.env.REACT_APP_FAVORITE_JOBS_LIMIT })}
      </p>
      <img
        className="modal__image"
        src={`${process.env.REACT_APP_ASSETS_BASE_PATH}/image/plus-signs-and-heart.svg`}
        alt=""
      />
    </Modal>
  );
}

export default injectIntl(SaveJobModal);
